import React, { useContext, useEffect,  useState } from 'react';
import { BIZCONTA_DEEPLINKING, ONBOARDING_DEEPLINKING } from 'env';
import { ApolloClientName } from 'apollo-client-factory';
import { useCompanyInfoQuery } from 'generated/credit-analysis-graphql';
import AppStores from 'components/bizos/app-stores';
import BizosList, { BizosListItem } from 'components/bizos/bizos-list';
import BizosTypograph from 'components/bizos/bizos-typography';
import BizosButton from 'components/bizos/bizos-button';
import BizosLogo from 'components/bizos/bizos-logo';
import { PartnersListMode } from 'components/partners-list/partners-list.utils';
import { useGetLoanQuery } from 'generated/graphql';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';

import 'containers/loan-denied.styles.scss';



type PartnersListProps = {
    showArrows: boolean;
    mode: PartnersListMode;
}

type RequestDeniedLayoutProps = {
    screenProfile?: 'default' | 'partners';
    partnersListProps?: PartnersListProps;
}

const RequestDeniedLayout: React.FC<RequestDeniedLayoutProps> = () => {
    const [email, setEmail] = useState<string>('');
    const [deepLinking, setDeepLinking] = useState(ONBOARDING_DEEPLINKING);
    const { loanApplicationId } = useContext(LoanApplicationContext);

    const { data:loanApplicationData } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    const { data } = useCompanyInfoQuery({
        variables: { loanApplicationId },
        skip: !loanApplicationId,
        context: { clientName: ApolloClientName.CreditAnalysisApi },
    });

    useEffect(() => {
        loanApplicationData?.loanApplication
        && setEmail(loanApplicationData?.loanApplication?.borrower?.email);
    }, [loanApplicationData]);

    useEffect(() => {
        if (data?.companyInfo?.id) {
            const linking = `${BIZCONTA_DEEPLINKING}/${data.companyInfo.id}`;
            setDeepLinking(linking);
        }
    }, [data]);

    return (
        <div className="loan-denied">
            <div className="loan-denied__container">
                <header className="loan-denied__header">
                    <BizosTypograph variant="heading-1" weight="bold">ainda não temos uma oferta. Enquanto isso, abra sua BizConta! 🎉 </BizosTypograph>
                    <BizosTypograph variant="subtitle">Explicamos o motivo de não termos uma oferta em seu e-mail {email}</BizosTypograph>
                </header>
            </div>
            <div className="loan-denied__container loan-denied__container loan-denied__container--shadow-large">
                <div className="loan-denied__content">
                    <BizosLogo />
                    <BizosTypograph>
                        Complete seu cadastro e abra a BizConta,<BizosTypograph variant="text" weight="bold"> conta PJ digital gratuita</BizosTypograph>:
                    </BizosTypograph>
                    <BizosList>
                        <BizosListItem color="gray" icon="arrows">
                            TED e Pix <strong>grátis</strong>
                        </BizosListItem>
                        <BizosListItem color="gray" icon="barcode">
                            Quite seus boletos e <strong> pague após 30 dias <br className="hidden-md" />com o Mais Biz*</strong> <br />
                            <small>*sujeito à análise. CET de até 10% a.m.</small>
                        </BizosListItem>
                        <BizosListItem color="gray" icon="clock">
                            Use o mesmo e-mail para terminar <br className="hidden-md" />o cadastro em <br className="hidden-sm" />poucos minutos:
                            <strong> {email}</strong>
                        </BizosListItem>
                    </BizosList>
                    <AppStores
                        text="aponte a câmera do seu celular para o QR code para acessar a loja de aplicativos"
                    />
                </div>
            </div>
            <div className="loan-denied__container loan-denied__container--shadow-small loan-denied__footer">
                <div className="loan-denied__button-wrapper">
                    <a href={deepLinking} target="_blank" referrerPolicy="no-referrer">
                        <BizosButton>Continuar com BizConta</BizosButton>
                    </a>
                </div>
            </div>
        </div>
    )
};

export default RequestDeniedLayout;
